import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g transform="translate(3)">
      <path d="M22,2 L17,2 L17,0 L15,0 L15,2 L12,2 L12,0 L10,0 L10,2 L7,2 L7,0 L5,0 L5,2 L0,2 L0,28 L22,28 L22,2 Z M20,26 L2,26 L2,4 L5,4 L5,6 L7,6 L7,4 L10,4 L10,6 L12,6 L12,4 L15,4 L15,6 L17,6 L17,4 L20,4 L20,26 Z"/>
      <polygon points="24 7 24 30 5 30 5 32 26 32 26 7"/>
      <rect width="12" height="2" x="5" y="12" className="euiIcon__fillSecondary"/>
      <rect width="12" height="2" x="5" y="17" className="euiIcon__fillSecondary"/>
    </g>
  </svg>
);
